import { React, useState } from 'react';
import { Grid, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Add, Groups } from '@mui/icons-material';
import axios from 'axios';
import '../../App.css';
import AddEmployeeForm from './AddEmployeeForm';
import EmployeeMasterTable from '../table-data/EmployeeMasterTable';
import Popup from '../Popup';
import { setLoaderMessage } from '../../utils/loaderManager';

function ViewEmployees() {
  const [openPopup, setOpenPopup] = useState(false);
  const [showExEmployees, setShowExEmployees] = useState(false);
  const [exEmployees, setExEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleCloseModal = () => {
    setOpenPopup(false);
  };

  const handleShowExEmployees = async () => {
    setLoading(true);
    setShowExEmployees(true);
    setLoaderMessage('Loading ex-employees...');
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/employee-master/get-leaved-employees`
      );
      setExEmployees(res.data);
    } catch (error) {
      setExEmployees([]);
    }
    setLoading(false);
  };

  const handleShowCurrentEmployees = () => {
    setShowExEmployees(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: '6px',
        padding: '30px',
        fontWeight: '500px',
        marginTop: '-10px',
      }}
    >
      <Paper elevation={0} sx={{ width: '1500px' }}>
        <Grid className="form-title" style={{ marginBottom: '-73px' }} container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: 'center', margin: 5 }}>
              View Employees
            </Typography>
          </Grid>
          <Grid item>
            <Groups style={{ marginLeft: '-30px' }} sx={{ width: 45, height: 45 }} />
          </Grid>
        </Grid>
        <Stack spacing={2} sx={{ alignItems: "flex-end", marginRight: "30px" }}>
          <Button
            style={{ width: "200px" }}
            className="form-btn"
            variant="outlined"
            color="success"
            onClick={() => setOpenPopup(true)}
            startIcon={<Add sx={{ width: "24px", height: "24px" }} />}
            sx={{
              whiteSpace: "nowrap",
              textTransform: "none"
            }}
          >
            Add New Employee
          </Button>
          <Stack direction="row" spacing={2} style={{ marginBottom: "-15px" }}>
          <Button
            style={{ width: "200px" }}
            variant={showExEmployees ? "outlined" : "contained"}
            color="primary"
            onClick={handleShowCurrentEmployees}
            sx={{
              whiteSpace: "nowrap",
              textTransform: "none"
            }}
          >
            View Current Employees
          </Button>
          <Button
            style={{ width: "200px" }}
            variant={showExEmployees ? "contained" : "outlined"}
            color="info"
            onClick={handleShowExEmployees}
            sx={{
              whiteSpace: "nowrap",
              textTransform: "none"
            }}
          >
            View Ex Employees
          </Button>
        </Stack>
        </Stack>
        <form autoComplete="off" onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ margin: '30px' }}>
            {showExEmployees ? (
              <EmployeeMasterTable
                data={exEmployees}
                loading={loading}
                ex={true}
                onExListRefresh={handleShowExEmployees}
              />
            ) : (
              <EmployeeMasterTable />
            )}
          </Stack>
        </form>
        <Popup
          title="Add New Employee"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          maxWidth="sm"
          fullWidth={false}
          sx={{
            '& .MuiPaper-root': {
              width: '400px',
              maxWidth: '400px',
            },
          }}
        >
          <AddEmployeeForm fetch_id={9999} onCloseModal={handleCloseModal} />
        </Popup>
      </Paper>
    </Box>
  );
}

export default ViewEmployees;
